import { Component, OnInit, ViewChild } from '@angular/core';
import { AssociateService } from '../../shared/services/associate.service';
import { TrainingService } from '../../shared/services/training.service';
import { Configuration } from '../../app.constants';
import { NgForm } from '@angular/forms';
import { ToastService } from '../../shared/services/toast.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import {Course} from '../trainingClass'
import { OrganizationService } from '../../shared/services/organization.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { DeletePopupComponent } from '../../shared/components/delete-popup/delete-popup.component';
import { MatDialog, Sort } from '@angular/material';

@Component({
  selector: 'app-add-course',
  templateUrl: './add-course.component.html',
  styleUrls: ['./add-course.component.css']
})
export class AddCourseComponent implements OnInit {

  public training  = Object.assign({},new Course().object);
  public associateList: any;
  public addedAssocaites=[];
  public serverApiUrl: string;
  public searchNameBeh = new BehaviorSubject<string>('');
  public searchNameObs = this.searchNameBeh.asObservable();
  public isSearch = false;
  
  @ViewChild('myForm')
  public myForm: NgForm ;
  public query: any;
  public search= {fullName:'', jobCategory:'',country:'',gender:'',company:''};
  public staticDD: any;
  public organizations: any;
  public user: any;
  public errors: any;
  public searchQuery = {name:'', company:'', status: ''};


  // paginator
  public pageSizeOptions = [ 5, 10, 15, 25, 50, 100];
  public pageSize = 10;
  public pageIndex = 0;


  constructor(
    private associateService:AssociateService,
    private trainingService:TrainingService,
    public config: Configuration,
    public toastService:ToastService,
    public staticDDListService: StaticValueService,
    public organizationService: OrganizationService,
    public router:Router,
    public auth: AuthService,
    public dialog: MatDialog,
  
  ) {
    this.staticDDListService.getStaticValues().then(data=>{
      this.staticDD = JSON.parse(JSON.stringify(data.staticDD));
      this.training.domain = this.staticDD.training.domains[0];
      this.staticDDListService.getErrors().then(error=>{
        this.errors = error;
      });
    })
    this.organizationService.getOrganization().subscribe(orgs => {
      this.organizations = orgs;
    }, error => {});
   }

  ngOnInit() {
    this.user = this.auth.user;
    this.training['active']=true;
    this.serverApiUrl = this.config.StaticImageUrl;

    this.query = {
      search: {
          'active': true,
          'contractDetails.activeStatus': { $ne: 'Inactive' },
          'personalInformation.fullName': { '$regex': '', $options: 'i' },
          // 'team': ''
      },
      sort: { 'personalInformation.familyName': 1 },
      pagination: {
          pageIndex: 0,
          pageSize: 50
      }
    };

    this.searchNameObs.pipe(debounceTime(700)).subscribe(value => {
      if(this.isSearch === false){
        this.search.fullName = value;
        this.associateSearch();  
      } else {
        this.searchQuery.name = value;
        this.searchAddedAssociate();
      }
    })

    this.associateSearch();
    // this.associateService.getAllAssociates(0,20).subscribe(data => {
    //   this.associateList = data;
    // })
  }

  nameSearched() {
    if(this.isSearch){
      this.searchNameBeh.next(this.searchQuery.name);
    } else {
      this.searchNameBeh.next(this.search.fullName);
    }
  }

  sortData(sort: Sort) {
    this.query.sort = {};
    if (sort.direction === 'asc') {
        this.query.sort[sort.active] = -1;
    } else if (sort.direction === 'desc') {
        this.query.sort[sort.active] = 1;
    }
    this.searchAddedAssociate();
  }


  associateSearch(){
    this.query.search['personalInformation.fullName'] = { $regex: this.search.fullName, $options: 'i' };
    this.query.search['jobDescription.company.id'] = { $regex: this.search.company, $options: 'i' };
    this.query.search['workContactDetails.workCountry'] = { $regex: this.search.country, $options: 'i' };
    this.query.search['jobDescription.jobCategory'] = { $regex: this.search.jobCategory, $options: 'i' };
    this.query.search['personalInformation.gender'] = this.search.gender;

    this.associateService.getAssociateSearch(0,50,this.query.search,this.query.sort).subscribe(data=>{
      this.associateList = data['data'];
    })
  }

  submit(){
    if(this.myForm.valid){
      
      this.training.lastEditedBy.name = this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name;
      this.training.lastEditedBy.id = this.user.associateId;
      this.training.lastEditedBy.time = new Date();

      this.trainingService.addCourse(this.training).subscribe(data =>{
        this.toastService.success();
        this.router.navigate(['/home/training/courses']);
      },error=>{
        this.toastService.error(this.errors['Server']['501']);
      })
    } else {
      this.toastService.error(this.errors['Client']['401']);
    }
  }

  addAssociate(associate){

    const index= this.training.associateIds.map(function(e) { return e.id; }).indexOf(associate._id);
    if (index === -1){
      this.training['associateIds'].push({id:associate._id,status:'In Progress'});
      this.addedAssocaites.push(associate);
      this.toastService.success();
    } else {
      console.log('already exites');
    }
  }

  removeAssociate(associate){
    let dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '300px',
      data: {},    
    });
    
    dialogRef.afterClosed().subscribe(response=>{
      if(response==='Proceed'){
        let index = this.addedAssocaites.indexOf(associate);
        this.addedAssocaites.splice(index,1);
        index= this.training.associateIds.map(function(e) { return e.id; }).indexOf(associate._id);
        this.training.associateIds.splice(index,1);
      }
    })
  }


  searchAddedAssociate(){
    let tempSearchQuery = {};
      if(this.searchQuery.status === ""){
        tempSearchQuery['_id']= this.training.associateIds.map(function(e) { return e.id; });
      } else {
        tempSearchQuery['_id']= this.training.associateIds.filter(e => e.status === this.searchQuery.status ).map(function(e){ return e.id });
      }

      tempSearchQuery['jobDescription.company.id'] = { $regex: this.searchQuery.company, $options: 'i' };
      tempSearchQuery['personalInformation.fullName'] = { $regex: this.searchQuery.name, $options: 'i' };
      this.associateService.getAssociateSearch(this.pageIndex,this.pageSize,tempSearchQuery,this.query.sort).subscribe(data=>{
        this.addedAssocaites = data? data['data']: [];
      });
  }

  getServerData(event) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.searchAddedAssociate();
  }

}
